import { type RootState } from "~/redux/store";
import { useSelector } from "react-redux";

const getCurrentStepIndex = (state: RootState) => state.linearConfigurator.currentStep;
const getLinearConfigurator = (state: RootState) => state.linearConfigurator;

export const KbComponent = () => {
  const currentStepIndex = useSelector(getCurrentStepIndex);
  const linearConfiguratorState = useSelector(getLinearConfigurator);
  const queryString = window.location.search;

  const showList = queryString.includes("showdetails=true") && currentStepIndex === 0;

  if (showList && linearConfiguratorState?.kbInfo.length > 0) {
    return (
      <>
        {linearConfiguratorState.kbInfo.map((kb, index) => (
          <p key={index}>{kb}</p>
        ))}
      </>
    );
  }
  return null;
};
